import messages from './messages'
import participants from './participants'
import lastRead from './last-read'

export default function (_this) {
  return {
    messages: messages(_this),
    participants: participants(_this),
    lastRead: lastRead(_this)
  }
}
